import * as React from 'react';
import classnames from 'classnames';

import InputRadio from 'components/inputs/input-radio/InputRadio';

import './radio-buttons.scss';

import type { TextEntry } from 'types';

type Option = {
  value: string,
  name: string
};

type Props = {
  direction: 'column' | 'row',
  selected: string,
  options: Array<Option>,
  onChange: (a: string) => void
};

class RadioButtons extends React.PureComponent<Props> {
  static defaultProps = {
    direction: 'column'
  };

  handleChanged = (selected: string) => {
    const { onChange } = this.props;

    if (!selected) {
      return;
    }

    onChange(selected);
  };

  handleSelectionChange = (event: React.SyntheticEvent<HTMLSpanElement>) => {
    event.preventDefault();

    const type = (event.currentTarget.dataset.arg) || '';

    this.handleChanged(type);
  };

  handleRadioChanged = (event: React.SyntheticEvent<TextEntry>) => {
    const type = event.currentTarget.value;

    this.handleChanged(type);
  };

  render(): React.ReactNode {
    const { direction, selected, options } = this.props;
    const classes = classnames({
      'radio-buttons': true,
      [`radio-buttons--direction-${direction}`]: direction
    });

    return (
      <section className={classes}>
        {
          options.map(option => {
            const itemClasses = classnames({
              'radio-buttons__item': true,
              [`radio-buttons__item--${option.value}`]: true
            });

            return (
              <div
                className={itemClasses}
                key={option.value}
                data-arg={option.value}
                onClick={this.handleSelectionChange}
              >
                <InputRadio
                  name="radio-buttons"
                  id={`radio-buttons-chooser-${option.value}`}
                  value={option.value}
                  checked={option.value === selected}
                  label={option.name}
                  onChange={this.handleRadioChanged}
                />
              </div>
            );
          })
        }
      </section>
    );
  }
}

export default RadioButtons;
